import Toastr from "../../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  day_end_report_payments: {},
  meta: { pagination: {} },
  loading: false,
  editing: false,
}

let changes = null;
export default function dailyReportReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  switch (action.type) {
    case 'DAY_END_REPORT_LOAD_PENDING':
      return { ...state, loading: true };

    case 'DAY_END_REPORT_LOAD_REJECTED':
    case 'DAY_END_REPORT_PRINT_REJECTED':
    case 'DAY_END_REPORT_DOWNLOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        loading: false
      }
      return { ...state, ...changes };

    case 'DAY_END_REPORT_LOAD_FULFILLED':
      changes = {
        day_end_report_payments: response,
        loading: false,
      };
      return { ...state, ...changes };

    case 'DAY_END_REPORT_EDIT':
      return { ...state, editing: { ...state.editing, ...action.payload } }

    case 'DAY_END_REPORT_EDIT_CANCEL':
      return { ...state, editing: false}

    default:
      return state;
  }
}
